import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';
import { stripHtml } from '@/utils';

export const addPolicySchema = z.object({
  name: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.policy.name.required)
    .min(3, VALIDATION_MESSAGES.policy.name.min)
    .max(150, VALIDATION_MESSAGES.policy.name.max),

  description: z
    .string()
    .trim()
    .refine(
      (val) => {
        const text = stripHtml(val);
        return !!text;
      },
      { message: VALIDATION_MESSAGES.policy.description.required }
    )
    .refine(
      (val) => {
        const text = stripHtml(val);
        return text && text.length >= 10;
      },
      { message: VALIDATION_MESSAGES.policy.description.min }
    ),
  // .refine(
  //   (val) => {
  //     const text = stripHtml(val);
  //     return text && text.length <= 5000;
  //   },
  //   { message: VALIDATION_MESSAGES.policy.description.max }
  // ),
});
export type TAddPolicyFormValues = z.infer<typeof addPolicySchema>;
